import React , {useState} from 'react'  ;
import { useSelector } from 'react-redux';


import CardFormule from '../../Components/CardsFormule/CardFormule';

import { useDevis } from '../../state/reactquery';

import './ListeFormules.scss';

const classNames = require('classnames');
function  ListeFormules({typeliste , dispfiltrebesoins}){
  const lead = useSelector(state=>state.lead.leadactu) ;
  const idsNeeds= useSelector(state=>state.formules.idsNeeds) ;
  const listecompagniesaffichees =  useSelector(state=>state.formules.listecompagniesaffichees);

  const {data: devis} = useDevis(lead?.id) ; 
  const {datas:formules, loadingformules} = useSelector(state=>state.formules);


  const [choicedformule, setChoicedformule] = useState({}) ;
  const ids_datasformules= formules?.map(x=>x.id);
  const listidformules = [devis?.id_1,devis?.id_2,devis?.id_3]?.filter(x=>x!==undefined && x!==null)
                                                              ?.filter(x=>ids_datasformules.indexOf(x)!==-1);

                                                        
  const formulesdevis = formules.filter(f=>listidformules.includes(f.id));

  const formulesbycompagnies = formules.filter(x=>listecompagniesaffichees.indexOf(x.compagnie)!==-1).sort((a,b)=>a.prix-b.prix) ; 
  const formulesbycompagniesandneeds = formules.filter(x=>listecompagniesaffichees.indexOf(x.compagnie)!==-1 && idsNeeds?.includes(x.id)).sort((a,b)=>a.prix-b.prix) ; 

  const formulesclient = (dispfiltrebesoins && idsNeeds?.length!==0) ?formulesbycompagniesandneeds :  formulesbycompagnies  ; 

  const listeformules =  typeliste==='souscription'   ? formulesdevis : formulesclient ;


  return(<div id='divformules'  className={classNames('listeformules',typeliste)}>
          
            {loadingformules?<div  className='loaderformules'></div>:
              formules.length >0 ? listeformules.map(f=><CardFormule key={f.id}
                                                                         dispfiltrebesoins={dispfiltrebesoins}
                                                                        formule={f} 
                                                                        typeliste={typeliste} 
                                                                        choicedformule={choicedformule} 
                                                                        setChoicedformule={setChoicedformule}/>):
                            <div  className='pasdeformule'>Aucune formule trouvée pour ce profil.</div>
                  }

        </div>)
}



export default ListeFormules ;

